import { ALMCreateAndLeverage__factory } from './typechain/ALMCreateAndLeverage__factory';
import BaseService from '../commons/BaseService';
export class ALMCreateAndLeverage extends BaseService {
    constructor({ provider, createAndLeverageAddress }) {
        super(provider, ALMCreateAndLeverage__factory);
        this.createAndLeverageAddress = createAndLeverageAddress !== null && createAndLeverageAddress !== void 0 ? createAndLeverageAddress : '';
    }
    mint({ depositParams, positionInitParams }) {
        const tx = {};
        tx.data = ALMCreateAndLeverage__factory.createInterface().encodeFunctionData('mint', [depositParams, positionInitParams]);
        tx.to = this.createAndLeverageAddress;
        tx.from = depositParams.receiver;
        return tx;
    }
}
//# sourceMappingURL=index.js.map